<div class="panel">
  <div (click)="togglePanelActive()" [class.active]="isPanelActive" class="panel-head">
    <label class="panel-label">{{ headerTitle }}</label>

    <div class="actions-wrapper">
      @if (showActionButtons) {
        <div class="actions">
          <!--          <app-icon (click)="hide.emit(1)" [planeIcon]="true" iconName="eye-close"></app-icon>-->
          <app-icon color="var(--slate-gray)" (click)="$event.stopPropagation(); edit.emit(id)" [planeIcon]="true" iconName="pencil"></app-icon>
          <app-icon color="var(--slate-gray)" (click)="$event.stopPropagation(); delete.emit(id)" [planeIcon]="true" iconName="trash-bin"></app-icon>
        </div>
      }

      <app-icon [iconName]="isPanelActive ? 'chevron-up' : 'chevron-down'" [planeIcon]="true" class="up-down-action" size="12px"></app-icon>
    </div>
  </div>

  <div [class.active]="isPanelActive" class="panel-body">
    <ng-content></ng-content>

    @if (showActionButtons) {
      <div class="actions">
        <!--      <app-icon (click)="hide.emit(1)" class="action" [planeIcon]="true" iconName="eye-close"></app-icon>-->
        <app-icon (click)="edit.emit(id)" [planeIcon]="true" class="action" color="var(--slate-gray)" iconName="pencil"></app-icon>
        <app-icon (click)="delete.emit(id)" [planeIcon]="true" class="action" color="var(--slate-gray)" iconName="trash-bin"></app-icon>
      </div>
    }
  </div>
</div>
